import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import PrivateRoute from "./privateRoute";
import MentorList from "../pages/mentorat/MentorList";
import LoginPage from "../pages/auth/Login";
import TableauDeBord from "../pages/tableauDeBord/TableauDeBord";
import Evenements from "../pages/evenements/Evenements";
import Forum from "../pages/forum/Forum";
import Formation from "../pages/formation/Formation";
import UserInfo from "../pages/profil/UserInfo";
import Aide from "../pages/aide/Aide";
import AddedMentor from "@/pages/mentorat/AddedMentor";
import ChatApp from "@/pages/mentorat/Chat";
import ProgrammedSessions from "@/pages/mentorat/ProgrammedSessions";
import ResetPassword from "@/pages/auth/MdpOublierProcess/ResetPassword";
import CreateNewPassword from "@/pages/auth/MdpOublierProcess/NewPassword";
import PasswordSuccess from "@/pages/auth/MdpOublierProcess/PasswordSuccess";
import MentoratPage from "@/pages/mentorat/MentoratPage";
import ProjetIntegrations from "@/pages/mesProjets/ProjectIntegrations";
import ProjetFichiers from "@/pages/mesProjets/ProjectFiles";
import ProjetNotifications from "@/pages/mesProjets/ProjectNotifications";
import ProjetMembres from "@/pages/mesProjets/ProjectMembers";
import ProjetDiscussions from "@/pages/mesProjets/ProjectDiscussions";
import ProjetTaches from "@/pages/mesProjets/ProjectTasks";
import ProjetGeneral from "@/pages/mesProjets/ProjectGeneral";
import SingleProjet from "@/pages/mesProjets/SingleProjet";
import ProjetCardList from "@/pages/mesProjets/ProjectCardList";
import ProjetPage from "@/pages/mesProjets/ProjectPage";
import ResourcePage from "@/pages/resources/ResourcesPage";
import NotFound from "@/pages/notfound";
import { UserRoles } from "@/types/enums/actors-types";
import MentorshipRequests from "@/pages/mentorat/MentorRequest";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import SessionManager from "@/components/SessionManager";
import TermsOfUse from "@/pages/legal/TermsOfUse";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Admin routes */}
        <Route
          path="/flowAdministration"
          element={<PrivateRoute requiredRole={UserRoles.ADMIN} />}
        >
          <Route
            path="/flowAdministration/tableauDeBord"
            element={<TableauDeBord />}
          />
        </Route>

        {/* Jeune Innovateur routes */}
        <Route
          path="/jeuneInnovateur"
          element={<PrivateRoute requiredRole={UserRoles.MEMBER} />}
        >
          <Route
            path="/jeuneInnovateur/tableauDeBord"
            element={<TableauDeBord />}
          />

          <Route
            path="/jeuneInnovateur/mesProjets"
            element={
              <ProjetPage>
                <Outlet />
              </ProjetPage>
            }
          >
            <Route
              path="/jeuneInnovateur/mesProjets/projetList"
              element={<ProjetCardList />}
            />

            <Route
              path="/jeuneInnovateur/mesProjets/singleProjet"
              element={
                <SingleProjet>
                  <Outlet />
                </SingleProjet>
              }
            >
              <Route
                path="/jeuneInnovateur/mesProjets/singleProjet"
                element={<ProjetGeneral />}
              />
              <Route
                path="/jeuneInnovateur/mesProjets/singleProjet/taches"
                element={<ProjetTaches />}
              />
              <Route
                path="/jeuneInnovateur/mesProjets/singleProjet/dicussions"
                element={<ProjetDiscussions />}
              />
              <Route
                path="/jeuneInnovateur/mesProjets/singleProjet/membres"
                element={<ProjetMembres />}
              />
              <Route
                path="/jeuneInnovateur/mesProjets/singleProjet/notifications"
                element={<ProjetNotifications />}
              />
              <Route
                path="/jeuneInnovateur/mesProjets/singleProjet/fichiers"
                element={<ProjetFichiers />}
              />
              <Route
                path="/jeuneInnovateur/mesProjets/singleProjet/integrations"
                element={<ProjetIntegrations />}
              />
            </Route>
          </Route>

          <Route path="/jeuneInnovateur/evenements" element={<Evenements />} />

          <Route
            path="/jeuneInnovateur/mentorat"
            element={
              <MentoratPage>
                <Outlet />
              </MentoratPage>
            }
          >
            <Route path="/jeuneInnovateur/mentorat" element={<AddedMentor />} />
            <Route
              path="/jeuneInnovateur/mentorat/conversations"
              element={<ChatApp />}
            />
            <Route
              path="/jeuneInnovateur/mentorat/sessions"
              element={<ProgrammedSessions />}
            />
            <Route
              path="/jeuneInnovateur/mentorat/listeMentors"
              element={<MentorList />}
            />
            <Route
              path="/jeuneInnovateur/mentorat/requests"
              element={<MentorshipRequests />}
            />
          </Route>

          <Route path="/jeuneInnovateur/resources" element={<ResourcePage />} />

          <Route path="/jeuneInnovateur/forum" element={<Forum />} />

          <Route path="/jeuneInnovateur/formation" element={<Formation />} />

          <Route path="/jeuneInnovateur/profil" element={<UserInfo />} />

          <Route path="/jeuneInnovateur/aide" element={<Aide />} />
        </Route>

        {/* Investisseur routes */}
        <Route
          path="/investisseur"
          element={<PrivateRoute requiredRole={UserRoles.INVESTISSEUR} />}
        >
          <Route
            path="/investisseur/tableauDeBord"
            element={<TableauDeBord />}
          />
        </Route>

        {/* Mentor routes */}
        <Route
          path="/mentor"
          element={<PrivateRoute requiredRole={UserRoles.MENTOR} />}
        >
          <Route path="/mentor/tableauDeBord" element={<TableauDeBord />} />
        </Route>

        {/* Visiteur routes */}
        <Route
          path="/visiteur"
          element={<PrivateRoute requiredRole={UserRoles.VISITEUR} />}
        >
          <Route path="/visiteur/tableauDeBord" element={<TableauDeBord />} />
        </Route>

        {/* Default route for non-logged-in users */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/resetPassword" element={<ResetPassword />} />
        <Route
          path="/auth/reset-password/:uidb64/:token"
          element={<CreateNewPassword />}
        />
        <Route
          path="/login/resetPassword/successPage"
          element={<PasswordSuccess />}
        />
        <Route
          path="/auth/verify-email/:uidb64/:token"
          element={<VerifyEmail />}
        />
        <Route path="/conditions-utilisation" element={<TermsOfUse />} />
        <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
      </Routes>
      <SessionManager />
    </Router>
  );
};

export default AppRoutes;
